import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useProjectsQuery = (userId: string | undefined) => {
  const { users } = useAvApi();

  return useQuery({
    queryKey: ['projects', userId],
    queryFn: async () => {
      if (userId) {
        const { data: projects } = await users.getV2UsersProjects();

        const sortedProjects = [...projects].sort(
          (a, b) =>
            (b.lastActivity || b.createdAt) - (a.lastActivity || a.createdAt)
        );

        return sortedProjects;
      }
    },
  });
};
